<template>
  <div class="body">
    <header />
    <main-page />
    <services-grid />
    <about-self />
    <portfolio-grid />
    <reviews-section />
    <contacts-page />
    <footer />
  </div>
</template>

<script setup>
import Header from '@/components/Header.vue';
import Footer from '@/components/Footer.vue';
import AboutSelf from '@/components/mainbloc/AboutSelf.vue';
import MainPage from '@/components/mainbloc/MainPage.vue';
import ServicesGrid from '@/components/mainbloc/ServicesGrid.vue';
import ContactsPage from '@/components/mainbloc/ContactsPage.vue';
import PortfolioGrid from '@/components/mainbloc/PortfolioGrid.vue';
import ReviewsSection from '@/components/mainbloc/ReviewsSection.vue';

const components = {
  Header,
  Footer,
  AboutSelf,
  MainPage,
  ServicesGrid,
  PortfolioGrid,
  ContactsPage,
  ReviewsSection,
};
</script>